import { createSlice } from '@reduxjs/toolkit';

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    id: null,
    loading: false,
    loaderType: "clear" // or boxed
  },
  reducers: {
    setLoadingState: (state) => { state.loading=true },
    loadSession: (state, action) => {
      state.id = action.payload;
      state.loading = false;
    },
    loadFlexParams: (state, action) => { state.flexParams=action.payload },
    setLoaderType: (state, action) => { state.loaderType=action.payload },
  },
  selectors: {
    selectId: (state) => state.id,
    selectLoading: (state) => state.loading,
    selectLoaderType: (state) => state.loaderType,
    selectFlexParams: (state) => state.flexParams,
    selectError: (state) => state.error
  }
});

export const { setLoadingState, loadSession, loadFlexParams, setLoaderType } = sessionSlice.actions;

export const { selectId, selectLoading, selectError, selectFlexParams, selectLoaderType } = sessionSlice.selectors;

export default sessionSlice.reducer;
